import type { Certification, Education } from './types';

export const education: Education[] = [
  {
    id: 'uta',
    institution: 'The University of Texas at Arlington',
    degree: 'Master of Science',
    field: 'Computer Science',
    location: 'Arlington, TX',
    startYear: 2023,
    endYear: 2025,
    startMonth: 8,
    endMonth: 5,
    coursework: [
      'Machine Learning',
      'Software Engineering',
      'Database Systems',
      'Secure Application Development',
      'Full Stack Development',
      'Cloud and Web Application Projects',
    ],
  },
  {
    id: 'vignan',
    institution: "Vignan's Foundation for Science, Technology & Research",
    degree: 'Bachelor of Technology',
    field: 'Information Technology',
    location: 'Guntur, India',
    startYear: 2015,
    endYear: 2019,
    grade: 'CGPA 7.7',
  },
];

export const certifications: Certification[] = [
  {
    id: 'az900',
    name: 'Microsoft Certified: Azure Fundamentals (AZ-900)',
    issuer: 'Microsoft',
  },
];
